export const PC_BOUNDARY = 992
export const PHONE_BOUNDARY = 480
export const SEPARATER = "\r\n"
